import React, { useState } from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import {
  Box,
  Card,
  Grid,
  InputLabel,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { downloadPdfCustodyOrderApi } from "../../../../services/documentServices";

import InputField from "../../../../common/InputField";
import download from "../../../../assets/images/download.png";

import "./CustodyOrder.scss";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Spinner } from "phosphor-react";

const CustodyOrder = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [isFetching, setIsFetching] = useState(false);
  const validate = Yup.object({
    place_date: Yup.string()
      .required(t("required"))
      .max(50, t("max-50-characters")),
    sign_1: Yup.string().required(t("required")),
    sign_2: Yup.string().required(t("required")),
  });
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  async function downloadPdf() {
    setIsFetching(true);
    await downloadPdfCustodyOrderApi(id, t);
    setIsFetching(false);
  }

  return (
    <Card className="custody-order">
      <Grid container>
        <Grid item lg={10} md={10} sm={12} xs={12} className="outer">
          <Typography variant="h4" fontWeight={"bold"}>
            {t("sidebar-3-text-4")}
          </Typography>
          <Typography variant="p" sx={{ mt: 2 }}>
            {t("custody-order-temp-text")}
          </Typography>
          <Typography variant="p" sx={{ mb: 2, mt: 1 }}>
            {t("custody-order-temp-text-0")}
          </Typography>
          <div className="download">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              {isFetching ? (
                <Spinner />
              ) : (
                <img
                  src={download}
                  height={16}
                  width={16}
                  style={{ cursor: "pointer" }}
                  onClick={downloadPdf}
                />
              )}
              <Typography fontWeight={"bold"}>{t("download")}</Typography>
            </div>
          </div>
          <div
            className="content"
            style={{ width: `${matches ? "100%" : "84%"}` }}
          >
            <Box className="document">
              <div>
                <Typography>{t("custody-order-temp-desc-1")}</Typography>
                <br />
                <Typography>{t("custody-order-temp-desc-2")}</Typography>
                <br />
                <Typography>{t("custody-order-temp-desc-3")}</Typography>
                <br />
                <Typography>{t("custody-order-temp-desc-4")}</Typography>
                <br />
                <Typography>{t("custody-order-temp-desc-5")}</Typography>
                <br />
                <Typography>{t("custody-order-temp-desc-6")}</Typography>
                <br />
                <Typography>{t("custody-order-temp-desc-7")}</Typography>
                <br />

                <Formik
                  initialValues={{
                    place_date: "",
                    sign_1: "",
                    sign_2: "",
                  }}
                  enableReinitialize
                  validationSchema={validate}
                >
                  {(formik) => (
                    <Form>
                      <Grid container>
                        <Grid item lg={8} md={8} sm={12} xs={12}>
                          <InputField
                            fullWidth
                            variant="standard"
                            placeholder="Karlsruhe, 15th March 2022"
                            label={t("input-20")}
                            name="place_date"
                            type="text"
                            InputLabelProps={{ shrink: true }}
                            sx={{ mt: 2 }}
                          />
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <InputLabel sx={{ mt: 2 }}>
                            {t("doc-tab-3")}
                          </InputLabel>
                        </Grid>
                        <Grid item lg={4}>
                          <InputField
                            fullWidth
                            variant="standard"
                            placeholder="Erika Mustermann"
                            name="sign_1"
                            type="text"
                            InputLabelProps={{ shrink: true }}
                            sx={{ mt: 2, pointerEvents: "none" }}
                          />
                        </Grid>
                        <Grid item lg={4} md={4} sm={12} xs={12}>
                          <InputField
                            fullWidth
                            variant="standard"
                            placeholder="Max Mustermann"
                            name="sign_2"
                            type="text"
                            InputLabelProps={{ shrink: true }}
                            sx={{ mt: 2, pointerEvents: "none" }}
                          />
                        </Grid>
                      </Grid>
                    </Form>
                  )}
                </Formik>
              </div>
            </Box>
          </div>
        </Grid>
      </Grid>
    </Card>
  );
};

export default CustodyOrder;
